// @flow
import type { ProductPayload, ProductSuggestion } from '@gandi/cart';
import { contactbook } from '@gandi/redux-resource-contactbook';

import type { TranslatorProps } from '@gandi/translate';

import { getBaseContact } from 'src/Cart/DomainContacts/Wizard/modules/actions';
import {
  selectCurrentContactByRoles,
  selectSetupOwner,
  selectShouldFetchFavoriteContacts,
} from 'src/Cart/Setup/modules/selectors';
import { selectDomainOwnerId } from 'src/Cart/modules/selectors';

import type { GetState, Dispatch } from '../../../../types';

export const getDomainContactPayload =
  (
    translator: TranslatorProps,
    /** the domain to add */
    product: ProductSuggestion,
  ): ((dispatch: Dispatch, getState: GetState) => Promise<ProductPayload>) =>
  async (dispatch: Dispatch, getState: GetState) => {
    const domainOwnerId = selectDomainOwnerId(getState());

    // Fetch owner data
    const prefillBaseContact = await dispatch(getBaseContact(translator));

    // fetch contactbook for other roles if needed
    if (
      selectShouldFetchFavoriteContacts(
        getState(),
        selectSetupOwner(getState()),
      )
    ) {
      // required by `selectCurrentContactByRoles`
      await dispatch(
        contactbook.fetchContactsWithRole(selectSetupOwner(getState())),
      );
    }

    // get `bill`, `admin` and `tech` roles from the contactbook if set
    // assuming here that we only deal with domain create
    const contacts = selectCurrentContactByRoles(getState(), 'create');

    // $FlowFixMe[cannot-spread-indexer]
    const payload = {
      ...product.payload,
      ...contacts,
      owner: {
        ...prefillBaseContact,
      },
      lastCurrentOrgaId: domainOwnerId,
    };

    // a beautiful payload with contact
    return payload;
  };
